import { h, Component } from "preact";
import { css } from "emotion";
import { hexToRgba } from "../../utils/Format";

/**
 * Display filter value (Date, location, and result count)
 *
 * @class FilterValueDisplay
 * @extends {Component}
 */
class FilterValueDisplay extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      date = false,
      location = false,
      totalSize = 0,
      listAndDate = false,
      theme
    } = this.props;

    const hideFilter = !date && !location;

    const customStyles = {
      wrapper: css`
        margin-bottom: ${listAndDate ? "0px" : "24px"};
        padding-top: ${listAndDate ? "16px" : "0px"};
        padding-bottom: ${listAndDate ? "12px" : "0px"};
        padding-left: ${listAndDate ? "12px" : "0px"};
        background: ${listAndDate
          ? hexToRgba(theme.eventCardBackgroundColor, theme.cardAndBarOpacity)
          : "transparent"};
        border-bottom: ${listAndDate ? "1px solid #dedede" : "none"};
        margin-top: ${listAndDate ? "0" : "5px"};
        display: ${listAndDate ? "none" : "block"};
        @media (max-width: 600px) {
          margin-top: 0px;
          display: block;
        }
      `,
      filterValue: css`
        color: ${theme.eventCardBackgroundColor === "#ffffff"
          ? "#323232"
          : "#ffffff"};
        font-weight: 600;
        font-size: 16px;
        display: inline-block;
        @media (max-width: 600px) {
          font-size: 14px;
        }
      `,
      eventCount: css`
        color: ${theme.eventCardBackgroundColor === "#ffffff"
          ? "#5a626c"
          : "#ffffff"};
        font-weight: 600;
        font-size: 16px;
        display: inline-block;
        margin-left: 5px;
        @media (max-width: 600px) {
          font-size: 14px;
        }
      `
    };

    if (hideFilter) {
      return <div />;
    }

    return (
      <div className={customStyles.wrapper}>
        <div className={customStyles.filterValue}>
          {location}
          {location && date ? ", " : null}
          {date},
        </div>
        <div className={customStyles.eventCount}>{totalSize} events</div>
      </div>
    );
  }
}

export default FilterValueDisplay;



// WEBPACK FOOTER //
// ./routes/tours/FilterValueDisplay.js